import React, { useState, useCallback, useEffect } from 'react';
import { GoogleMap, Marker, DirectionsRenderer, Polyline, OverlayView } from '@react-google-maps/api';

const defaultContainerStyle = {
  width: '100%',
  height: '100%',
};

const defaultOptions = {
  disableDefaultUI: true,
  zoomControl: true,
  mapTypeControl: false,
  fullscreenControl: false,
  streetViewControl: false,
};

const CustomMarkerTransit = ({ position, flypro }) => {
  console.log(flypro)
  return (
    <OverlayView
      position={position}
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
    >
      <div className="map-marker transit-flypro">
        <div className="marker-body hotel-item">
          <img className='hotel-image' src={flypro?.media?.length ? flypro.media[0]?.original_url : '/assets/images/dashboard-home-page-image.png'} alt='Flypro_image' />
        </div>
        <img src='/assets/images/tail.svg' alt='images' className="marker-tail" />
      </div>
    </OverlayView>
  );
};

export const Map = ({
  coordinates = [],
  mode = 'view',
  onCoordinateChange = () => { },
  mapOptions = defaultOptions,
  containerStyle = defaultContainerStyle,
  routeMarkers = [],
  therapist,
  address,
}) => {
  const [markers, setMarkers] = useState([]);
  const [directions, setDirections] = useState(null);

  //logic for track line
  const [startTime, setStartTime] = useState(null);
  const [progressPercentage, setProgressPercentage] = useState(0);

  useEffect(() => {
    if (directions?.routes?.length) {
      setStartTime(new Date());
    }
  }, [directions]);

  useEffect(() => {
    if (!startTime || !directions) return;

    const durationInSeconds = directions.routes[0].legs[0].duration.value;

    const interval = setInterval(() => {
      const now = new Date();
      const elapsed = (now - startTime) / 1000; // in seconds
      const progress = Math.min((elapsed / durationInSeconds) * 100, 100);
      setProgressPercentage(progress);
    }, 1000);

    return () => clearInterval(interval);
  }, [startTime, directions]);

  // end logic


  useEffect(() => {
    if (
      routeMarkers.length === 2 &&
      routeMarkers[0]?.lat &&
      routeMarkers[1]?.lat
    ) {
      const directionsService = new window.google.maps.DirectionsService();

      directionsService.route(
        {
          origin: { lat: routeMarkers[0].lat, lng: routeMarkers[0].lng },
          destination: { lat: routeMarkers[1].lat, lng: routeMarkers[1].lng },
          travelMode: window.google.maps.TravelMode.DRIVING,
        },
        (result, status) => {
          if (status === window.google.maps.DirectionsStatus.OK) {
            setDirections(result);
          } else {
            console.error("Directions request failed due to ", status);
            setDirections(null);
          }
        }
      );
    } else {
      setDirections(null);
    }
  }, [JSON.stringify(routeMarkers)]);



  useEffect(() => {
    if (coordinates.length > 0) {
      setMarkers(coordinates);
    }
  }, [coordinates]);


  const handleDragEnd = useCallback(
    (event, index) => {
      const updatedCoordinates = [...markers];
      updatedCoordinates[index] = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng(),
      };
      setMarkers(updatedCoordinates);
      onCoordinateChange(updatedCoordinates);
    },
    [markers, onCoordinateChange]
  );
  const startLoc = directions?.routes[0]?.legs[0]?.start_location;
  const endLoc = directions?.routes[0]?.legs[0]?.end_location;

  // Check if locations are nearly the same
  const isTooClose =
    Math.abs(startLoc?.lat() - endLoc?.lat()) < 0.0001 &&
    Math.abs(startLoc?.lng() - endLoc?.lng()) < 0.0001;

  // If too close, apply a tiny offset to end marker
  const adjustedEndLoc = isTooClose
    ? {
      lat: endLoc?.lat() + 0.00015,
      lng: endLoc?.lng() + 0.00015,
    }
    : endLoc;

  const travelTime = directions?.routes[0]?.legs[0]?.duration?.text || '';
  // const progressPercentage = 60;


  return (
    <div className="map-container">
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={mode === 'edit' && markers.length === 1 ? markers[0] : markers[0] || { lat: 46.2643, lng: 6.3166 }}
        zoom={16}
        options={mapOptions}
      >
        {!directions && markers.map((coordinate, index) => (
          <Marker
            key={index}
            position={coordinate}
            draggable={mode === 'edit' && markers.length === 1}
            onDragEnd={(event) => handleDragEnd(event, index)}
          />
        ))}
        {directions && (
          <>
            <Marker
              position={startLoc}
              icon={{
                // url: 'http://maps.google.com/mapfiles/ms/icons/blue.png',
                url: 'https://maps.google.com/mapfiles/kml/paddle/wht-blank.png',
              }}
            />

            <Marker
              position={adjustedEndLoc}
              icon={{
                // url: 'http://maps.google.com/mapfiles/ms/icons/yellow.png',
                url: 'https://maps.google.com/mapfiles/kml/paddle/blu-blank.png',
              }}
            />
            <CustomMarkerTransit
                  position={startLoc}
                  flypro={therapist}
                />
            <Polyline
              path={directions.routes[0].overview_path}
              options={{
                strokeColor: '#4285F4',
                strokeOpacity: 0.8,
                strokeWeight: 5,
              }}
            />
          </>
        )}

        {travelTime && (
          <div
            style={{
              position: 'absolute',
              bottom: '20px',
              left: '50%',
              transform: 'translateX(-50%)',
              backgroundColor: 'white',
              padding: '16px',
              borderRadius: '12px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
              fontSize: '14px',
              fontWeight: '500',
              zIndex: 1,
              width: '350px',
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              {therapist?.media?.length > 0 && (
                <img
                  src={`${therapist?.media?.length ? therapist.media[0].original_url : "assets/images/icon-pro.svg"}`}
                  alt="Therapist"
                  style={{ width: '50px', height: '50px', borderRadius: '50%', objectFit: 'cover' }}
                />
              )}
              <div>
                <div style={{ fontWeight: '600', fontSize: '16px' }}>
                  {`${therapist?.firstname || ''} ${therapist?.lastname || ''}`}
                </div>
              </div>
            </div>
            <div style={{ fontSize: '15px', color: '#333' }}>
                  <p>{`${address?.street || ''} ${address?.street_number || ''}`}</p>
                  <p>{`${address?.zip_code || ''}, ${address?.state || ''}`}</p>
                </div>


            <div style={{
              height: '8px',
              width: '100%',
              backgroundColor: '#e0e0e0',
              borderRadius: '4px',
              overflow: 'hidden',
            }}>
              <div style={{
                height: '100%',
                width: `${progressPercentage}%`,
                backgroundColor: 'yellow',
                transition: 'width 0.3s ease',
              }} />
            </div>
            <div className='text-center'>{travelTime} left to arrive</div>

          </div>
        )}


      </GoogleMap>

    </div>
  );
};
